// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-detail-text {
    color: #333333;
    font-size: 18px;
    padding: 5px;
  }

.post-detail-heading{
    color: #000;
    font-size: 18px;
    padding: 5px;
    font-weight: bold;
}
.section-post{
    display: flex;
    flex-direction: column;
    justify-content: left;
    padding: 10px 0;
}

.ingredients-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/Assets/Postsmanage.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,YAAY;EACd;;AAEF;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".post-detail-text {\r\n    color: #333333;\r\n    font-size: 18px;\r\n    padding: 5px;\r\n  }\r\n\r\n.post-detail-heading{\r\n    color: #000;\r\n    font-size: 18px;\r\n    padding: 5px;\r\n    font-weight: bold;\r\n}\r\n.section-post{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: left;\r\n    padding: 10px 0;\r\n}\r\n\r\n.ingredients-list{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
